module.exports = __webpack_public_path__ + "static/media/UFV.db17bf27.jpg";